export default __webpack_public_path__ + "static/media/10.dd4a127b.jpg";